import { ApiErrorData } from '../types';

export class ApiError extends Error {
  public status: number;
  public errorCode: string;
  public details?: unknown;
  public data: ApiErrorData;

  constructor(status: number, data: ApiErrorData) {
    super(data.message);
    this.name = 'ApiError';
    this.status = status;
    this.errorCode = data.errorCode;
    this.details = data.details;
    this.data = data;

    // Restore prototype chain for custom error classes in TypeScript
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
